import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
/**
 * Created by Alican Köker on 2018-07-19.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TweenLite} from "gsap";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReelSymbol} from "../../reelsymbol/FruitsReelSymbol";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";
import {FruitsHelper} from "../../utils/FruitsHelper";
import {FruitsReels} from "../reelarea/FruitsReels";
import {FruitsReelAttentionView} from "./FruitsReelAttentionView";

export interface IHighlightingReel {
    positionIndex:[number, number];
    linesToHighlight:[[number, number]];
}

export class FruitsReelAttentionController extends ReelStopPresentationController {
    private _orientation:Orientation;
    private _reelsToHighlight:IHighlightingReel[];
    private _soundEffectPlayedFor:boolean[] = [false, false, false, false];
    private _randomFeatureAttention:boolean = false;
    private _featureData:FruitsParsedGameData;
    private _isExcitementSpinTriggered:boolean;
    private _bigWinExcitementPositions:boolean[][];
    private _bigWinExcitementPositionsPortrait:boolean[][];
    private _attentionView:FruitsReelAttentionView;
    private _parsedRandomOverlayPositions:number[];
    private _randomOverlayTriggered:boolean;
    private _randomOverlaySymbol:string;

    private _timeLine:TimelineLite | null;

    private _stopCounter = 0;
    private _attentionReel = 3;

    constructor(index:number) {
        super(index, "ReelStopAttention");

        EventHandler.addEventListener(this, FruitsReels.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
        this._attentionView = new FruitsReelAttentionView();
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {

        this._isExcitementSpinTriggered = data.isExcitementSpinTriggered;
        this._bigWinExcitementPositions = data.bigWinExcitementPositions;
        this._bigWinExcitementPositionsPortrait = data.bigWinExcitementPositionsPortrait;
        this._parsedRandomOverlayPositions = data.parsedRandomOverlayPositions;
        this._randomOverlayTriggered = data.randomSymbolOverlayTriggered;
        this._randomOverlaySymbol = data.randomOverlaySymbol;

        this._stopCounter = 0;

        this._reelsToHighlight = [];
        for(let i:number = 4; i < GameConfig.instance.REELS_NUM; i++) {
            let reelRowIndex:number = i < 4 ? Math.floor(i / 2) : Math.floor((i - 4) / 3 + 2);
            let reelColIndex:number = i < 4 ? i % 2 : (i - 4) % 3;

            this.createLinesToHighlight([reelRowIndex, reelColIndex], <IBetLineWinData[]>this._gameData!.betWins!, this._reelsToHighlight);
        }

        this._soundEffectPlayedFor = [false, false, false, false];

        this._randomFeatureAttention = this.determineRandomFeatureAttention();
        this._featureData = data;
    }

    private determineRandomFeatureAttention():boolean {
        let nearWinPositions:boolean[][] = this._orientation === Orientation.PORTRAIT ? (<FruitsParsedGameData>this._gameData!).nearWinPositionsPortrait :
            (<FruitsParsedGameData>this._gameData!).nearWinPositions;

        return nearWinPositions[1][2] || nearWinPositions[1][1];
    }

    private evaluateAttentionPositions(reel:number):void {
        let posCheck:boolean[][] = this._orientation === Orientation.LANDSCAPE ? this._bigWinExcitementPositions : this._bigWinExcitementPositionsPortrait;

        let nearWinPositions:boolean[][] = this._orientation === Orientation.PORTRAIT ? (<FruitsParsedGameData>this._gameData!).nearWinPositionsPortrait :
            (<FruitsParsedGameData>this._gameData!).nearWinPositions;

        if(posCheck[reel][0] || (nearWinPositions[reel][0] && nearWinPositions[reel][2])) {
            this._attentionView.getAttention(reel);
        }
    }

    private handleAttention(reelId:number):void {
        if(this._isExcitementSpinTriggered) {
            if(this._orientation === Orientation.LANDSCAPE) {
                reelId === 3 && this.evaluateAttentionPositions(2);
                reelId === 6 && this.evaluateAttentionPositions(3);
                reelId === 9 && this.evaluateAttentionPositions(4);
                reelId === 12 && this.evaluateAttentionPositions(5);
            } else {
                reelId === 2 && this.evaluateAttentionPositions(2);
                reelId === 4 && this.evaluateAttentionPositions(3);
                reelId === 7 && this.evaluateAttentionPositions(4);
                reelId === 10 && this.evaluateAttentionPositions(5);
            }
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        this._timeLine = new TimelineLite();
        this.handleAttention(data.reelId);
        this._stopCounter++;
        if(this._stopCounter == this._attentionReel && this._randomFeatureAttention && this._gameData!.mode !== FruitsGameMode.STICKY_RESPIN) {
            this._timeLine.add(FruitsGameModuleConfig.reelAttentionOverlayView.playRandomFeatureAttentionEffect());
        }

        if(data.reelId > 3 && this._gameData!.mode !== FruitsGameMode.STICKY_RESPIN && !this._gameData!.freespinTriggeredThisSpin) {
            this._timeLine.add(() => this.playWinLandingAttentionPing(data.reelId, data.quickStop));
        }

        this._timeLine.add(() => this.dispatchCompleteEvent(data.reelId));
    }

    private handleRandomFeature(reelId:number):void {
        if(this._parsedRandomOverlayPositions.indexOf(reelId) > -1) {
            let sym:FruitsReelSymbol = <FruitsReelSymbol>Reels.getSymbol(reelId, 0);
            if(sym) {
                sym.replaceWith(this._randomOverlaySymbol, reelId);
                FruitsGameModuleConfig.beforeSpinStopRandomFeatureView.resetReel(reelId);
            }
        }
    };

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._randomOverlayTriggered) {
            this.handleRandomFeature(data.reelId);
        }
    }

    playReelBouncingSound?(data:IReelStoppedData):boolean {
        return this.playLandingSound(data.reelId);
    }

    private playLandingSound(reelId:number):boolean {

        let firstReel:boolean = this._orientation === Orientation.LANDSCAPE ?
            reelId < 4 ? true : (reelId - 4) % 3 === 2 : reelId < 4 ? true : (reelId - 4) % 3 === 0;

        let isBonus:boolean = this._gameData!.mode === FruitsGameMode.BONUS_GAME;

        let hasOverlayOn:boolean = this.hasOverlaySymbol(reelId);

        if(firstReel && !isBonus && !hasOverlayOn) {
            SlotGame.sound.playEffect(FruitsSoundConfig.instance.REEL_BOUNCE);
            return true;
        }
        return false;
    }

    private hasOverlaySymbol(index:number):boolean {

        let isStickyOverlayOn:boolean = (this._featureData!.mode === FruitsGameMode.STICKY_RESPIN) &&
        index < 4 ? this._featureData!.overlayStickySymbolsBeforeSpin[index] :
            this._featureData!.overlayStickySymbolsBeforeSpin[index] && this._featureData!.overlayStickySymbolsBeforeSpin[index + 1] && this._featureData!.overlayStickySymbolsBeforeSpin[index + 2];

        let r:number = index < 4 ? Math.floor(index / 2) : Math.floor((index - 4) / 3 + 2);
        let s:number = index < 4 ? index % 2 + 1 : (index - 4) % 3;

        let isRandomOverlayOn:boolean = r < 2 ? this._featureData!.symbolOverlayPositions[r][s] :
            r % 3 === 0 && this._featureData!.symbolOverlayPositions[r][0] && this._featureData!.symbolOverlayPositions[r][1] && this._featureData!.symbolOverlayPositions[r][2]

        return isStickyOverlayOn || isRandomOverlayOn;
    }

    private playWinLandingAttentionPing(reelId:number, quickStop:boolean):void {
        let lineArr:IHighlightingReel[] = [];

        if(reelId % 3 === 0 && reelId !== 4 && this._gameData!.mode !== FruitsGameMode.STICKY_RESPIN) {
            for(let i:number = reelId - 2; i < reelId + 1; i++) {
                let reelRowIndex:number = Math.floor((i - 4) / 3 + 2);
                let reelColIndex:number = (i - 4) % 3;
                let lineToPlay:IHighlightingReel | null = this.getPositionData([reelRowIndex, reelColIndex], this._reelsToHighlight);
                if(lineToPlay)
                    lineArr.push(lineToPlay)
            }

            lineArr.forEach((lineToPlay) => {
                this._soundEffectPlayedFor = [false, false, false, false];
                let greatest:number = this.calculateRightMostWinningReel((lineToPlay.linesToHighlight));
                lineToPlay.linesToHighlight.forEach((line) => {
                    let rId:number = line[0] < 2 ? line[0] * 2 + line[1] - 1 : line[0] * 3 + line[1] - 2;

                    let sym:StateReelSymbol | null = Reels.getSymbol(rId, 0);
                    if(sym && sym.symName !== "S" && sym.symName !== "W") {
                        this.determineHighlightAnimTiming(quickStop, sym, greatest).play();
                    }
                });
            });
        }
    }

    private calculateRightMostWinningReel(linesToHighlight:[[number, number]]):number {
        let greatest:number = 0;
        linesToHighlight.forEach((line) => {
            if(line[0] > greatest)
                greatest = line[0];
        });
        return greatest;
    }

    private playPingSoundEffect(rId:number):void {
        if(rId > 1) {
            switch(rId) {
                case 2:
                    if(!this._soundEffectPlayedFor[0]) {
                        SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION1);
                        this._soundEffectPlayedFor[0] = true;
                    }
                    break;
                case 3:
                    if(!this._soundEffectPlayedFor[1]) {
                        SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION2);
                        this._soundEffectPlayedFor[1] = true;
                    }
                    break;
                case 4:
                    if(!this._soundEffectPlayedFor[2]) {
                        SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION3);
                        this._soundEffectPlayedFor[2] = true;
                    }
                    break;
                case 5:
                    if(!this._soundEffectPlayedFor[3]) {
                        SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION4);
                        this._soundEffectPlayedFor[3] = true;
                    }
                    break;
                default:
                    if(!this._soundEffectPlayedFor[0]) {
                        SlotGame.sound.playEffect(FruitsSoundConfig.WIN_ATTENTION1);
                        this._soundEffectPlayedFor[0] = true;
                    }
                    break;
            }
        }
    }

    private determineHighlightAnimTiming(quickStop:boolean, sym:StateReelSymbol, rId:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        let timeCoeff:number = quickStop ? .2 : .45;

        tl.add(() => {
            TweenLite.to(sym!.scale, .25 * timeCoeff, {x : 1.2, y : 1.2});
            this.playPingSoundEffect(rId);
        });
        tl.add(() => {
            TweenLite.to(sym!.scale, .75 * timeCoeff, {x : 1, y : 1});
            this.playPingSoundEffect(rId);
        }, .25 * timeCoeff);

        return tl;
    }

    private createLinesToHighlight(positionInd:[number, number], winReels:IBetLineWinData[], outputArr:IHighlightingReel[]):IHighlightingReel[] {

        winReels.forEach((winLine) => {
            this.addLightingLine(outputArr, winReels, positionInd);
        });

        return outputArr;
    }

    private addLightingLine(highlightArray:IHighlightingReel[], winReels:IBetLineWinData[], positionIndex:[number, number]):void {
        winReels.forEach((winReel) => {
            if(winReel.betLine[positionIndex[0]] === positionIndex[1] && positionIndex[0] < winReel.nrOfSymbols) {
                for(let i:number = 0; i < positionIndex[0] + 1; i++) {
                    let highlightReel:IHighlightingReel | null = this.getLine(positionIndex, highlightArray);
                    if(highlightReel) {
                        if(!this.isPositionAdded([i, winReel.betLine[i]], highlightReel.linesToHighlight)) {
                            highlightReel.linesToHighlight.push([i, winReel.betLine[i]]);
                        }
                    } else {
                        let line:[number, number] = [i, winReel.betLine[i]];
                        highlightReel = <IHighlightingReel>{
                            linesToHighlight : [line],
                            positionIndex : positionIndex,
                        };
                        highlightArray.push(highlightReel);
                    }
                }
            }
        });
    }

    private getLine(positionIndex:[number, number], highlightArray:IHighlightingReel[]):IHighlightingReel | null {
        for(let i:number = 0; i < highlightArray.length; i++) {
            if(highlightArray[i].positionIndex === positionIndex) return highlightArray[i];
        }
        return null;
    }

    private isPositionAdded(positionIndex:[number, number], addedLines:[[number, number]]):boolean {
        for(let i:number = 0; i < addedLines.length; i++) {
            if(JSON.stringify(positionIndex) === JSON.stringify(addedLines[i]))
                return true;
        }
        return false;
    }

    private getPositionData(positionIndex:[number, number], array:IHighlightingReel[]):IHighlightingReel | null {
        for(let i:number = 0; i < array.length; i++) {
            if(JSON.stringify(positionIndex) === JSON.stringify(array[i].positionIndex))
                return array[i];
        }
        return null;
    }

    private onOrientationChange(data:Orientation):void {
        this._orientation = data;

        if(this._timeLine) {
            this._timeLine.totalProgress(1);
            this._timeLine = FruitsHelper.timeLineNuller(this._timeLine);
        }
    }
}